export interface ValidatedUser {
  userName: string;
  userStatus: UserStatus;
  secretKey: string;
  securityUpdated: string;
  userEmail: string;
  textPhone: string;
}

export class ValidateUserRequest {
  captchaId: string;
  userEnteredCaptchaCode: string;
  recaptchaToken: string;
  userName: string;
  email: string;
  textphone: string;
  LanguageCode: string;

  constructor(init?: Partial<ValidateUserRequest>) {
    if (init) {
      Object.assign(this, init);
    }
  }
}

export class ValidateEmailRequest {
  captchaId: string;
  userEnteredCaptchaCode: string;
  recaptchaToken: string;
  useremail: string;
  sendEmail: string;
  LanguageCode: string;

  constructor(init?: Partial<ValidateEmailRequest>) {
    if (init) {
      Object.assign(this, init);
    }
  }
}

export class VerificationResponse {
  answerStatus: SecurtyAnswerStatus;
  inValidAnswer: number;
}

export enum UserStatus {
  Valid = 'Valid',
  NotFound = 'NotFound',
  Locked = 'Locked',
  Disabled = 'Disabled',
  DeadClient = 'DeadClient',
  ClientNotSetupYet = 'ClientNotSetupYet',
  BadCaptCha = 'BadCaptCha',
}

export enum SecurtyAnswerStatus {
  Failed = 'Failed',
  Disabled = 'Disabled',
  Success = 'Success',
  DisabledFailure = 'DisabledFailure',
}
